export const SET_FILTER = '@filters/SET_FILTER';
